"use client";
import AuthPage from "@/components/common/AuthPage/AuthPage";
import { useRouter, useSearchParams } from "next/navigation";

export default function Signup() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const slug = searchParams.get("slug");

  const handleEmailSignup = () => {
    let url = "/verify-email";
    if (slug) {
      url += `?slug=${slug}`;
    }
    router.push(url);
  };

  return (
    <AuthPage
      mode="signup"
      onEmailAuth={handleEmailSignup}
      redirectPath="/dashboard"
    />
  );
}
